import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import AppShell from "./AppShell";
import { GET, profile } from "../components/CustomComponent";

// Layout ของทุกหน้าในระบบ "กินอะไรดี": โครงเดียวกับ AppShell แต่สลับ navbar เป็นชุดของระบบนี้ (ธีมส้ม)
// เงื่อนไขการเข้าเหมือน CMRU: backend ติดธง profile.systems.food จาก allowlist (config/food.js)
// ถ้า cache โปรไฟล์ยังไม่มีค่า (เก่ากว่าระบบนี้) ให้ถาม backend ซึ่งเป็นตัวตัดสินจริง
export default function FoodShell({ title, description, children }) {
  const [allowed, setAllowed] = useState(profile?.systems?.food ? true : null);

  useEffect(() => {
    let isMounted = true;

    const verifyAccess = async () => {
      const result = await GET("v1/food/access", null, null, { silent: true });
      if (!isMounted) return;
      // network / server error ไม่นับว่าไม่มีสิทธิ์ คงสถานะเดิมไว้ (403 เท่านั้นที่เด้งออก)
      if (result?.status === true) setAllowed(true);
      else if (result?.status_code === 403) setAllowed(false);
      else setAllowed((current) => current ?? false);
    };

    verifyAccess();

    return () => {
      isMounted = false;
    };
  }, []);

  if (allowed === false) return <Navigate replace to="/welcome" />;

  return (
    <AppShell title={title} description={description} system="food">
      <div className="stg food">{allowed ? children : null}</div>
    </AppShell>
  );
}
